<template>
  <div class="company-detail-page">
    <!-- 顶部企业信息卡片 -->
    <el-card class="company-header-card" shadow="never">
      <div class="company-header">
        <div class="company-left">
          <div class="logo-wrapper">
            <img :src="$imagePath.image32" alt="" style="max-height: 22px;">
            <!-- <i class="el-icon-document-copy logo-icon"></i> -->
          </div>
          <div class="company-info">
            <h2 class="company-name">{{ companyInfo.name }}</h2>
            <div class="company-tags">
              <el-tag
                :class="index === 0 ? 'tag-back1' : 'tag-back2'"
                v-for="(tag, index) in companyInfo.tags"
                :key="tag"
                size="small"
                type="info"
                >{{ tag }}</el-tag
              >
            </div>
          </div>
        </div>
        <div class="update-time">{{ companyInfo.updateTime }} 更新</div>
      </div>

      <div class="company-base-info">
        <div class="info-row">
          <div
            class="info-item"
            v-for="(item, index) in companyInfo.baseInfoRow1"
            :key="index"
          >
            <span class="label">{{ item.label }}：</span>
            <span class="value">{{ item.value }}</span>
          </div>
        </div>
        <div class="info-row">
          <div
            class="info-item"
            v-for="(item, index) in companyInfo.baseInfoRow2"
            :key="index"
          >
            <span class="label">{{ item.label }}：</span>
            <span class="value">{{ item.value }}</span>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 企业简介和工商信息合并卡片 -->
    <el-card class="combined-card" shadow="never">
      <!-- 企业简介 -->
      <div class="section">
        <div class="section-header">
          <span>企业简介</span>
        </div>
        <div class="section-content">
          <p>{{ companyInfo.introduction }}</p>
        </div>
      </div>

      <!-- 工商信息 -->
      <div class="section">
        <div class="section-header">
          <span>工商信息</span>
        </div>
        <div class="section-content">
          <el-table
            :data="businessData"
            style="width: 100%"
            border
            :show-header="false"
          >
            <el-table-column prop="label" width="200"></el-table-column>
            <el-table-column prop="value"></el-table-column>
            <el-table-column prop="label2" width="200"></el-table-column>
            <el-table-column prop="value2"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "wechatBasicInfoIndex",
  data() {
    return {
      // 企业基本信息
      companyInfo: {
        name: "星瀚智联科技有限公司",
        tags: ["实体零售", "有公众号", "有小程序", "有PC端"],
        updateTime: "2025-10-10",
        baseInfoRow1: [
          { label: "法定代表人", value: "崔珊珊" },
          { label: "注册资本", value: "500万元" },
          { label: "联系电话", value: "18922224790" },
        ],
        baseInfoRow2: [
          { label: "地址", value: "黑龙江省肇东市砂河镇泉沟村119号" },
          { label: "经营范围", value: "计算机软硬件开发与销售" },
          { label: "成立日期", value: "2000-01-18" },
        ],
        introduction:
          "星瀚智联科技有限公司成立于2000年，是一家专注于智能科技领域的创新型企业。公司致力于为客户提供高品质的智能解决方案，涵盖物联网、人工智能、大数据等多个领域。凭借专业的技术团队和丰富的行业经验，公司已成为行业内的知名品牌，为众多企业和个人用户提供了优质的产品和服务。",
      },
      // 工商信息数据
      businessData: [
        {
          label: "统一社会信用代码",
          value: "24809098018860955026",
          label2: "注册号",
          value2: "46558500051113863724",
        },
        {
          label: "组织结构代码",
          value: "84983921716204391729",
          label2: "所属行业",
          value2: "互联网",
        },
        {
          label: "法定代表人",
          value: "崔珊珊",
          label2: "成立日期",
          value2: "2025-10-10",
        },
        {
          label: "公司类型",
          value: "有限责任公司",
          label2: "公司规模",
          value2: "500人",
        },
        {
          label: "注册资本",
          value: "500万元",
          label2: "企业地址",
          value2: "广东省新会市白马山庄02030号",
        },
      ],
    };
  },
};
</script>

<style scoped>
.company-detail-page {
  height: 100%;
  padding: 10px;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 顶部企业信息卡片 */
.company-header-card {
  flex-shrink: 0;
}
.company-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}
.company-left {
  display: flex;
  align-items: center;
}
.logo-wrapper {
  width: 48px;
  height: 48px;
  background-color: #e6f7ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.logo-icon {
  font-size: 24px;
  color: #1890ff;
}
.company-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}
.company-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.tag-back1 {
  background-color: #eef6ff;
  color: #348cf8;
}
.tag-back2 {
  background-color: #efefff;
  color: #8486f2;
}
.update-time {
  font-size: 14px;
  color: #999;
}
.company-base-info {
  padding-left: 60px;
  font-size: 14px;
  color: #666;
}
.info-row {
  display: flex;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.info-row:last-child {
  margin-bottom: 0;
}
.info-item {
  width: 33.33%;
  display: flex;
  margin-bottom: 8px;
}
.label {
  color: #999;
  margin-right: 4px;
}
.value {
  color: #333;
}

/* 合并卡片 */
.combined-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* 通用区块样式 */
.section {
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
}
.section-header {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  border-left: 3px solid #1890ff;
  padding-left: 12px;
  line-height: 1;
  margin-bottom: 16px;
}
.section-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  flex: 1;
  min-height: 0;

  p {
    margin: 0;
  }
}

/* 工商信息表格 */
::v-deep .el-table {
  height: 100%;

  .el-table__body-wrapper {
    height: calc(100% - 40px);
  }
}
::v-deep .el-table td {
  padding: 12px 0;
  color: #666;
}
::v-deep .el-table td:first-child,
::v-deep .el-table td:nth-child(3) {
  color: #999;
  background-color: #fafafa;
}
</style>
